import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_many_females_are_und_the_applicable_legal_minimum_working_a'

export const dataPointDefinition = {
  retracedId: 'how_many_females_are_und_the_applicable_legal_minimum_working_a',
  name: 'How many females are under the applicable legal minimum working age?',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-chi-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 4450,
  sectionId: '2.2.1',
  impactArea: 'Child Labour',
  impactAreaId: 'CHILD_LABOR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
